export default __webpack_public_path__ + "fk-cp-zion/img/fa_62673a.png";